// extracted by mini-css-extract-plugin
export default {"card":"errors_card__62+cU","container":"errors_container__OVhR6","img":"errors_img__qjlCT","btn":"errors_btn__3T71o"};